<template>
  <div :class="['v-global-input', css ? css : '', isError ? 'is-error' : '']">
    <label
      v-if="label"
      class="label"
    >
      {{ label }}
    </label>
    <span
      v-if="errorText"
      class="error-text"
    >
      {{ errorText }}
    </span>
    <input
      :id="id ? id : ''"
      ref="input"
      :value="value"
      :class="disable ? 'not_editable' : ''"
      :type="type ? type : null"
      :placeholder="placeholder ? placeholder : ''"
      :readonly="disable"
      :maxlength="maxLength || null"
      @change="onHandleChange"
      @input="onHandleInput"
    >
  </div>
</template>

<script>
export default {
  props: [
    'id',
    'label',
    'placeholder',
    'value',
    'type',
    'css',
    'handleChange',
    'handleInput',
    'isDisable',
    'isError',
    'errorText',
    'maxLength',
  ],
  data() {
    return {};
  },
  computed: {
    disable() {
      return this.isDisable;
    },
  },
  methods: {
    onHandleChange(e) {
      if (this.handleChange) {
        const newValue = e.target.value.trim();

        if (!newValue) {
          this.$refs.input.value = this.value;
          e.target.blur();

          return;
        }

        this.handleChange(newValue);
        e.target.blur();
      }
    },
    onHandleInput(e) {
      if (this.handleInput) {
        this.handleInput(e.target.value);
      }
    },
  },
};
</script>

<style scoped src='./vInput.less'></style>
